import API_CONFIG from '../config/api.config';
import apiClient from './apiClient';

const delay = (ms = API_CONFIG.MOCK_DELAY) => new Promise(r => setTimeout(r, ms));

const MOCK_BOOKINGS = [
  {
    _id: 'mock_booking_001', bookingRef: 'DB-2026-000001',
    sessionType: '1:1 Mentoring', sessionDate: new Date(Date.now() + 2 * 24 * 60 * 60 * 1000),
    sessionTime: '3:00 PM IST', durationMins: 60, priceINR: 1600,
    status: 'confirmed', meetingLink: 'https://meet.google.com/mock-link',
    mentorId: { slug: 'amar-krishnan', userId: { firstName: 'Amar', lastName: 'Krishnan' } },
    menteeId: { firstName: 'Priya', lastName: 'Sharma', email: 'priya@example.com' },
  },
  {
    _id: 'mock_booking_002', bookingRef: 'DB-2026-000002',
    sessionType: 'Code Review', sessionDate: new Date(Date.now() - 3 * 24 * 60 * 60 * 1000),
    sessionTime: '11:00 AM IST', durationMins: 45, priceINR: 1200,
    status: 'completed', meetingLink: 'https://meet.google.com/mock-link-2',
    mentorId: { slug: 'amar-krishnan', userId: { firstName: 'Amar', lastName: 'Krishnan' } },
    menteeId: { firstName: 'Priya', lastName: 'Sharma', email: 'priya@example.com' },
  },
];

const bookingService = {

  // ── Create booking ─────────────────────────────────────────
  async createBooking(data) {
    if (API_CONFIG.MOCK) {
      await delay();
      const booking = {
        id: `mock_booking_${Date.now()}`, bookingRef: `DB-2026-${String(Date.now()).slice(-6)}`,
        status: 'pending_payment', priceINR: 1600, platformFeeINR: 240, mentorEarningINR: 1360,
      };
      return {
        booking,
        razorpayOrder: { id: 'order_MOCK123', amount: 160000, currency: 'INR', key: 'rzp_test_mock' },
      };
    }
    return apiClient.post('/bookings', data);
  },

  // ── Get my bookings ────────────────────────────────────────
  async getBookings({ status, page = 1 } = {}) {
    if (API_CONFIG.MOCK) {
      await delay();
      let bookings = [...MOCK_BOOKINGS];
      if (status) bookings = bookings.filter(b => b.status === status);
      return { bookings, total: bookings.length, page, totalPages: 1 };
    }
    return apiClient.get('/bookings', { params: { status, page } });
  },

  // ── Get booking by ID ──────────────────────────────────────
  async getBooking(id) {
    if (API_CONFIG.MOCK) {
      await delay();
      const booking = MOCK_BOOKINGS.find(b => b._id === id) || MOCK_BOOKINGS[0];
      return { booking };
    }
    return apiClient.get(`/bookings/${id}`);
  },

  // ── Cancel booking ─────────────────────────────────────────
  async cancelBooking(id, reason) {
    if (API_CONFIG.MOCK) {
      await delay();
      return { message: '[MOCK] Booking cancelled.', booking: { status: 'cancelled' } };
    }
    return apiClient.post(`/bookings/${id}/cancel`, { reason });
  },

  // ── Complete booking ───────────────────────────────────────
  async completeBooking(id) {
    if (API_CONFIG.MOCK) {
      await delay();
      return { message: '[MOCK] Session completed.', booking: { status: 'completed' } };
    }
    return apiClient.post(`/bookings/${id}/complete`);
  },

  // ── Confirm booking (no payment) ──────────────────────────
  async confirmBooking(id) {
    if (API_CONFIG.MOCK) {
      await delay();
      return { booking: { status: 'confirmed' } };
    }
    return apiClient.post(`/bookings/${id}/confirm`).catch(() => ({ booking: { status: 'confirmed' } }));
  },

  // ── Reschedule booking ─────────────────────────────────────
  async rescheduleBooking(id, newDate, newTime) {
    if (API_CONFIG.MOCK) {
      await delay();
      return { message: '[MOCK] Booking rescheduled.' };
    }
    return apiClient.post(`/bookings/${id}/reschedule`, { newDate, newTime });
  },

  // ── Upcoming sessions ──────────────────────────────────────
  async getUpcomingSessions() {
    if (API_CONFIG.MOCK) {
      await delay();
      return { sessions: MOCK_BOOKINGS.filter(b => b.status === 'confirmed') };
    }
    return apiClient.get('/bookings/sessions/upcoming');
  },

  // ── Past sessions ──────────────────────────────────────────
  async getPastSessions() {
    if (API_CONFIG.MOCK) {
      await delay();
      return { sessions: MOCK_BOOKINGS.filter(b => b.status === 'completed') };
    }
    return apiClient.get('/bookings/sessions/past');
  },
};

export default bookingService;
